import { Link } from "react-router";
import { Cta } from "../components/Cta";
import { usePageMeta } from "../lib/usePageMeta";
import { Section } from "../components/Section";
import { Ticker } from "../components/Ticker";
import { IDEA, JOIN, MODELS, PERSONAS, PRICING_TEASER } from "../content/landing";
import { TICKER_ITEMS } from "../content/ticker";
import { ModelGrid } from "../features/catalogue/ModelGrid";
import { Hero } from "../features/landing/Hero";
import { Personas } from "../features/landing/Personas";
import styles from "./Landing.module.css";

export function Landing() {
  usePageMeta("landing");

  /* ── THE "Included today:" LINE CAME OFF THE LANDING PAGE (Ned, 2026-08-27) ──
     It read "Included today: NBA Fantasy (beta), NBA Sport (beta)" — a model
     inventory, complete with build tags, in the pricing teaser of a page whose
     job is to get a stranger interested. It answered a question nobody had got
     to yet, in the vocabulary of someone who already had an account.

     The line itself was well built and its comment was right: derived from the
     catalogue, never typed, so a model that ships or slips needs no copy edit.
     None of that is why it is gone. It is gone because the landing page was the
     wrong page for it.

     IT STILL EXISTS, AND DELIBERATELY SO. Pricing.tsx renders the same derived
     list beside each plan, where the reader IS asking what they get for the
     money, and that copy carries "Never hardcode this list" for a compliance
     reason — it is what stops a plan card promising a model that is not
     answering questions. Removing it there would be an overclaim; removing it
     here is an edit. `reachableModels` is untouched and still has that caller.

     The CTA one line below already sends anyone who wants the list to it. */

  return (
    <>
      <Hero />
      {/* Three short items don't fill a desktop viewport, so the run repeats to
          keep the loop seamless. Label is no longer "build status" — the strip
          stopped carrying build state on 2026-07-31. */}
      <Ticker items={TICKER_ITEMS} label="KEV" repeat={3} />

      <Section id="the-idea" eyebrow={IDEA.eyebrow} heading={IDEA.heading} tone="ink">
        <div className={styles.prose}>
          {IDEA.body.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </div>
      </Section>

      <Section
        id="personas"
        eyebrow={PERSONAS.eyebrow}
        heading={PERSONAS.heading}
        tone="deep"
      >
        <Personas />
      </Section>

      <Section
        id="the-models"
        eyebrow={MODELS.eyebrow}
        heading={MODELS.heading}
        tone="deep"
      >
        <ModelGrid />
      </Section>

      {/* "05 — The Ledger" removed 2026-08-03 (Ned): we stay silent on the
          record rather than promising a public one. Nothing replaces it, and
          Pricing takes 05 so the sequence has no gap. Guardrails §1.3 still
          bars any win-rate or ROI claim — removing the promise doesn't license
          the number; if anything it removes the section that was going to
          justify it. */}
      <Section
        id="pricing"
        eyebrow={PRICING_TEASER.eyebrow}
        heading={PRICING_TEASER.heading}
        tone="deep"
      >
        <div className={styles.pricingRow}>
          <div>
            <p className={styles.pricingBody}>{PRICING_TEASER.body}</p>
          </div>
          <Cta to="/pricing">{PRICING_TEASER.cta}</Cta>
        </div>
      </Section>

      {/* The page's last section, and now the only thing it asks anyone for.

          This was a mailing-list form until 2026-08-28. content/landing.ts
          holds the reasoning, including why deleting the consent clause that
          sat here is not a weakening of one — read that before reinstating any
          email capture on this page.

          Built inline on `.pricingRow` rather than as a component: what is left
          after the form is a paragraph and a button, and `Waitlist.tsx` existed
          for the submit state machine, not the layout. */}
      <Section id="join" eyebrow={JOIN.eyebrow} heading={JOIN.heading} tone="ink">
        <div className={styles.pricingRow}>
          <div>
            <p className={styles.pricingBody}>{JOIN.body}</p>
          </div>
          <Cta to="/signup">{JOIN.cta}</Cta>
        </div>
        <p className={styles.joinSignIn}>
          {JOIN.signInLead} <Link to="/login">{JOIN.signIn}</Link>
        </p>
      </Section>
    </>
  );
}
